<template lang="html">
    <div class="machine">
        <div class="plaque-machine">
            <div class="plaque-machine-frame">
                <el-row align="middle">
                    <h2>{{getTextArray('motor_nav')[3][getLangage]}}</h2>
                    <p class="subtitle">{{getText('motor_form_machine_choice')}}</p>

                    <el-form-item class="buttons" prop="trained_machine.infoTypeSelected" :show-message="false">
                        <el-button class="whiteButton" :class="{'selected': isSelectedType('power')}" @click="selectPower()">{{getText('motor_form_switch_inactive')}}</el-button>
                        <el-button class="whiteButton" :class="{'selected': isSelectedType('other')}" @click="selectOther()">{{getText('motor_form_switch_active')}}</el-button>
                    </el-form-item>

                    <div v-if="factoryMachine.infoTypeSelected == 'other'">
                        <div class="twoObjects">
                            <el-form-item class="input" :label="getText('motor_form_machine_pressure')" prop="trained_machine.pressure" :show-message="showMessage('pressure')">
                                <el-input type="number" v-model="factoryMachine.pressure"></el-input>
                            </el-form-item>
                            <el-form-item class="unit" :label="getText('motor_form_machine_pressure_unit')" prop="trained_machine.pressure_unit" :show-message="showMessage('pressure_unit')">

                                <el-select name="carcasse" id="carcasse" v-model="factoryMachine.pressure_unit" :placeholder="getText('motor_form_machine_pressure_unit_placeholder')" required>
                                    <el-option
                                        v-for="opt in ['bar', 'Pa', 'mCe']"
                                        :key="opt"
                                        :value="opt"
                                    >
                                        {{opt}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="twoObjects">

                            <el-form-item :label="getText('motor_form_machine_output')" class="input" prop="trained_machine.flow" :show-message="showMessage('flow')">
                                <el-input type="number" v-model="factoryMachine.flow"></el-input>
                            </el-form-item>
                            <el-form-item :label="getText('motor_form_machine_output_unit')" class="unit" prop="trained_machine.flow_unit" :show-message="showMessage('flow_unit')">
                                <el-select name="carcasse" id="carcasse" v-model="factoryMachine.flow_unit" :placeholder="getText('motor_form_machine_output_unit_placeholder')" required>
                                    <el-option
                                        v-for="opt in ['m³/s', 'm³/min', 'm³/h']"
                                        :key="opt"
                                        :value="opt"
                                    >
                                        {{opt}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <el-form-item :label="getText('motor_form_machine_efficiency')" prop="trained_machine.efficiency" :show-message="showMessage('efficiency')">
                            <el-tooltip class="formTooltip" effect="dark" placement="right" :content="getText('motor_form_machine_efficiency_tooltip')">
                                <el-input type="number" v-model="factoryMachine.efficiency"></el-input>
                            </el-tooltip>
                        </el-form-item>
                        <div v-if="machineInfoGathered" class="machineInfo">
                            <span>{{getText('motor_form_machine_pnMe_computed')}} : </span><span>{{computePnMe}} kW</span>
                        </div>
                    </div>
                    <el-form-item v-else-if="factoryMachine.infoTypeSelected == 'power'" :label="getText('motor_form_machine_power')" prop="trained_machine.pn_me" :show-message="showMessage('pn_me')">
                        <el-input type="number" v-model="factoryMachine.pn_me"></el-input>
                    </el-form-item>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            msg: '',
            // dataSelected: null
        };
    },
    props: {
        factoryEngine: {
            type: Object,
            required: true
        },
        factoryMachine: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        },
        formIntegrity: {
            type: Boolean
        }
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
            'getLangage'
        ]),
        machineInfoGathered() {
            return this.factoryMachine.pressure && this.factoryMachine.pressure_unit && this.factoryMachine.flow
                    && this.factoryMachine.flow_unit && this.factoryMachine.efficiency
                    && this.factoryMachine.efficiency <= 1;
        },
        computePnMe() {
            let theoreticalEfficiency = this.factoryEngine.nominal_power / (Math.sqrt(3) * this.factoryEngine.nominal_voltage * this.factoryEngine.nominal_current * this.factoryEngine.cos_phi / 1000);

            let machinePnMe = this.$store.getters.computePowerForFlowAndPressureInWatt({
                flow_value: this.factoryMachine.flow,
                flow_unit: this.factoryMachine.flow_unit,
                pressure_value: this.factoryMachine.pressure,
                pressure_unit: this.factoryMachine.pressure_unit,
                fluid_type: this.factoryEngine.application_type.endsWith('ventilation') ? 'air' : 'eau',
                efficiency: this.factoryMachine.efficiency,
            });

            //Convert in kW
            machinePnMe = machinePnMe / 1000;

            // this.factoryMachine.pn_me = machinePnMe;
            let locale = this.getLangage == 'fr' ? 'fr-FR' : 'en-EN';
            return new Intl.NumberFormat(locale, { style: 'decimal' }).format(machinePnMe.toFixed(3));
        }
    },
    methods: {
        selectPower() {
            this.$emit('changeInfoType', 'power');
        },
        selectOther() {
            this.$emit('changeInfoType', 'other');
        },
        isSelectedType(msg) {
            return this.factoryMachine.infoTypeSelected == msg;
        },
        showMessage(el) {
            if (this.factoryMachine[el].length)
                return true;
            return false;
        },

        toggleValue() {
            this.switchValue = !this.switchValue;
        },
    },
};
</script>

<style lang="less">

@import '../../../less/variables';
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outter-spin-button {
    -webkit-appearance: none;
}

.machine {
    .plaque-machine {
        width: 100%;
        .subtitle {
            text-align: center;
            margin: 40px 0;
            font-size: 16px;
        }
        .buttons {
            text-align: center;
            .selected {
                background-color: @color-1;
                color: white;
            }
        }
    }
    .plaque-machine-frame {
        margin: 20px 0;
        padding: 5px 15px 40px 15px;
        border: 5px solid #efefef;
        .machineInfo {
            width: 100%;
            text-align: center;
            margin-top: 40px;
        }
    }
    h2 {
        font-weight: bold;
        text-transform: uppercase;
    }
}

.twoObjects {
        display: flex;
        align-items: center;
        flex-direction: row;
        .input {
            align-self: flex-start;
            width: 50%;
        }
        .unit {
            align-self: flex-end;
            width: 30%;
            margin: auto;
            .el-input {
                font-size: 15px;
            }
        }
}

.el-switch__label.is-active {
    color: @color-1;
}

.machineSwitch {
    display: flex !important;
    flex-direction: row;
    justify-content: space-around;
    text-align: center;
    width: 80%;
    margin: 50px auto 20px;
    span {
        font-size: 21px !important;

    }
}

.el-select-dropdown__item {
    font-size: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/partials/wizzard/MachineForm.vue